export default {
    name: 'small-loader',
    data() {
        return {}
    }

}
